const SideHustleInitialText ="This is your opportunity to make some additional money. " +
    "Several side hustle options are displayed below.  Choose the one that sounds best " +
    "to you."
        
export default SideHustleInitialText 
 